import globals from "imports/globals";
import $ from "cash-dom";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    $(document).ready(function () {
        if ($(".read-more-link").length) {
            if (globals.debug) console.log("component-read-more initialized");
            $(".read-more-link").on("click", function (_e) {
                _e.preventDefault();
                var target = $(_e.target).closest("button");
                var targetText = target.find("span");
                var overflow = target.parents(".layout").find(".read-more-content")[0];

                if (overflow.style.height) {
                    targetText.text(globals.strings.read_more);
                    target.attr("title", globals.strings.read_more);
                    overflow.style.height = null;
                } else {
                    targetText.text(globals.strings.read_less);
                    target.attr("title", globals.strings.read_less);
                    overflow.style.height = `${overflow.scrollHeight}px`;
                }
            });
        }
    });
})();

export default component;
